var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.193 29.9905C35.6983 29.8951 39 29.0737 39 27.5264C39 24.2283 35.6421 21.5547 31.5 21.5547C30.3442 21.5547 29.2496 21.7628 28.2718 22.1346C30.6844 23.8988 32.25 26.4512 32.25 29.4271C32.25 29.6235 32.23 29.8113 32.193 29.9905Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9525 21.9746C9.4131 23.7426 7.75 26.3599 7.75 29.4271C7.75 29.6179 7.76887 29.8006 7.80392 29.9752C4.23995 29.8268 1 29.0105 1 27.5264C1 24.2283 4.58172 21.5547 9 21.5547C10.0428 21.5547 11.039 21.7036 11.9525 21.9746Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14C26 17.3137 23.3137 20 20 20C16.6863 20 14 17.3137 14 14C14 10.6863 16.6863 8 20 8C23.3137 8 26 10.6863 26 14Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12 17.2091 10.2091 19 8 19C5.79086 19 4 17.2091 4 15C4 12.7909 5.79086 11 8 11C10.2091 11 12 12.7909 12 15Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15C36 17.2091 34.2091 19 32 19C29.7909 19 28 17.2091 28 15C28 12.7909 29.7909 11 32 11C34.2091 11 36 12.7909 36 15Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 22C14.1693 22 10 25.6791 10 29.6049C10 29.657 10.014 29.8551 10.4517 30.1818C10.8941 30.512 11.6108 30.8427 12.5992 31.1296C14.5604 31.6988 17.2517 32 20 32C22.7483 32 25.4396 31.6988 27.4008 31.1296C28.3892 30.8427 29.1059 30.512 29.5483 30.1818C29.986 29.8551 30 29.657 30 29.6049C30 25.6791 25.8307 22 20 22Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrg);
export default __webpack_public_path__ + "static/media/iconOrg.36d2d4a2.svg";
export { ForwardRef as ReactComponent };